import { Navigate, Route, Routes } from 'react-router-dom';
import { useAuth } from './lib/auth';
import { Login } from './pages/Login';
import { SignInComplete } from './pages/SignInComplete';
import { Inbox } from './pages/work/Inbox';
import { CaseInbox } from './pages/work/CaseInbox';
import { CaseDetail } from './pages/work/CaseDetail';
import { FlowDefinitions } from './pages/flow/Definitions';
import { FlowDefinitionDetail } from './pages/flow/DefinitionDetail';
import { SlaDashboard } from './pages/flow/SlaDashboard';
import { Templates } from './pages/notify/Templates';
import { Broadcasts } from './pages/notify/Broadcasts';
import { PostalQueue } from './pages/notify/PostalQueue';
import { LegalBasisPage } from './pages/consent/LegalBasis';
import { DocTypes } from './pages/docs/DocTypes';
import { VerifyConsole } from './pages/docs/Verify';
import { Addresses } from './pages/addresses/Addresses';
import { Officers } from './pages/admin/Officers';
import { RoleGrants } from './pages/admin/RoleGrants';
import { Delegations } from './pages/admin/Delegations';
import { OrgChart } from './pages/admin/OrgChart';
import { Launcher } from './pages/launcher/Launcher';
import { Shell, type NavItem, type NavHeader } from './ui/Shell';

const NAV: Array<NavItem | NavHeader> = [
  { header: 'My Work' },
  { to: '/inbox', label: 'Inbox', icon: '✉' },
  { to: '/cases', label: 'Cases', icon: '▤', exact: false },

  { header: 'Case Management' },
  { to: '/flow/definitions', label: 'Flow definitions', icon: '⚙' },
  { to: '/flow/sla', label: 'SLA dashboard', icon: '◔' },

  { header: 'Notifications' },
  { to: '/notify/templates', label: 'Templates', icon: '✎' },
  { to: '/notify/broadcasts', label: 'Broadcasts', icon: '⚑' },
  { to: '/notify/postal', label: 'Postal queue', icon: '▣' },

  { header: 'Consent & Legal Basis' },
  { to: '/consent/legal-basis', label: 'Legal basis matrix', icon: '⚖' },

  { header: 'Documents' },
  { to: '/docs/types', label: 'Doc types', icon: '▥' },
  { to: '/docs/verify', label: 'Verify', icon: '✓' },

  { header: 'Addresses' },
  { to: '/addresses', label: 'Address register', icon: '⌂' },

  { header: 'Admin' },
  { to: '/admin/officers', label: 'Officers', icon: '◈' },
  { to: '/admin/role-grants', label: 'Role grants', icon: '⇄' },
  { to: '/admin/delegations', label: 'Delegations', icon: '⇉' },
  { to: '/admin/org-chart', label: 'Org chart', icon: '▦' },

  { header: 'Launcher' },
  { to: '/launcher', label: 'Other portals', icon: '◫' },
];

export function App() {
  const { persona } = useAuth();

  if (!persona) {
    return (
      <Routes>
        <Route path="/signin/complete" element={<SignInComplete />} />
        <Route path="*" element={<Login />} />
      </Routes>
    );
  }

  return (
    <Routes>
      <Route path="/" element={<Shell title={persona.org} items={NAV} />}>
        <Route index element={<Navigate to="/inbox" replace />} />
        <Route path="inbox" element={<Inbox />} />
        <Route path="cases" element={<CaseInbox />} />
        <Route path="cases/:ref" element={<CaseDetail />} />
        <Route path="flow/definitions" element={<FlowDefinitions />} />
        <Route path="flow/definitions/:code" element={<FlowDefinitionDetail />} />
        <Route path="flow/sla" element={<SlaDashboard />} />
        <Route path="notify/templates" element={<Templates />} />
        <Route path="notify/broadcasts" element={<Broadcasts />} />
        <Route path="notify/postal" element={<PostalQueue />} />
        <Route path="consent/legal-basis" element={<LegalBasisPage />} />
        <Route path="docs/types" element={<DocTypes />} />
        <Route path="docs/verify" element={<VerifyConsole />} />
        <Route path="addresses" element={<Addresses />} />
        <Route path="admin/officers" element={<Officers />} />
        <Route path="admin/role-grants" element={<RoleGrants />} />
        <Route path="admin/delegations" element={<Delegations />} />
        <Route path="admin/org-chart" element={<OrgChart />} />
        <Route path="launcher" element={<Launcher />} />
        <Route path="*" element={<Navigate to="/inbox" replace />} />
      </Route>
    </Routes>
  );
}
